import './styles'
import veevalidate from './vee-validate'
import elementui from './element-ui'
import Notifications from '../src/components/NotificationPlugin';
import SideBar from '../src/components/SidebarPlugin';
import clickOutside from '../src/directives/click-ouside.js';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import VueFlatPickr from 'vue-flatpickr-component';

export default {
  install(Vue) {
    veevalidate(Vue);
    elementui(Vue);
    Vue.use({
      install(Vue) {
        Vue.directive('click-outside', clickOutside);
      }
    });
    Vue.use(SideBar);
    Vue.use(Notifications);
    Vue.use(BootstrapVue);
    Vue.use(IconsPlugin);
    Vue.use(VueFlatPickr);
  }
};